import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";

import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import EmployeeAttendanceSection from "../components/employeeAttendance/employeeAttendanceSection";

const FETCH_GLOBALS = gql`
  query ($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
      }
    }
  }
`;

class EmployeeAttendance extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    const globals = this.props.globals;
    const loading = globals.loading;
    const error1 = globals.error;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser == true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              {loading == true ? (
                <Container>
                  <Row>
                    <Col sm={12}>
                      <div className="d-flex align-items-center spinner-border text-primary text-center loading-img-center"></div>
                    </Col>
                  </Row>
                </Container>
              ) : (
                <>
                  {(() => {
                    let globalsData = globals.globals;

                    if (
                      Cookies.get("userlevel") != "1" &&
                      Cookies.get("userlevel") != "2"
                    ) {
                      let globalBranches = [];

                      globalsData.globalBranches.map((item) => {
                        if (Cookies.get("branch_id") == item.id) {
                          globalBranches.push(item);
                        }
                      });

                      globalsData.globalBranches = globalBranches;
                    }
                    console.log("globalsData", globalsData);

                    return (
                      <>
                        <EmployeeAttendanceSection globals={globalsData} />
                      </>
                    );
                  })()}
                </>

                // <EmployeeAttendanceSection
                //     globals={globals.globals}
                // />
              )}
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(FETCH_GLOBALS, {
        options: (props) => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
        }),
        name: "globals",
      }),
    )(EmployeeAttendance),
  ),
);
